import PropTypes from "prop-types";
import CenterDivModal from "../CenterDivModal";
import FaceEmoji from "../../common/FaceEmoji";
import { DOH } from "../../common/FaceEmoji/constants";
import SignInOrJoinButton from "../../../containers/customerItems/SignInOrJoinButton";
import content from "app-content";
import styles from "./index.css";

const SignInModalMessage = ({ onClosed }) => (
  <CenterDivModal onClosed={onClosed}>
    <div className={styles.signInModalMessage}>
      <FaceEmoji type={DOH} />
      <div className={styles.text}>
        <h2 className={styles.title}>
          {content.back_in_stock_sign_in_modal_heading}
        </h2>
        <p className={styles.prompt}>
          {content.back_in_stock_sign_in_modal_title}
        </p>
        <p className={styles.prompt}>
          {content.back_in_stock_sign_in_modal_text}
        </p>
      </div>
      <SignInOrJoinButton className={styles.button} />
    </div>
  </CenterDivModal>
);

SignInModalMessage.propTypes = {
  onClosed: PropTypes.func.isRequired
};

export default SignInModalMessage;
